export * from './baSidebar.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baSidebar/index.ts